import * as React from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { hasValue } from './inputHelpers';

interface IProps {
  name: string
  maxLength?: number
}

const XTextInput = ({ name, maxLength, margin = 'dense', ...props }: TextFieldProps & IProps) => {
  const [field, meta] = useField({ name });
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  const currentLength = (field.value || '').length;
  const helperText = showError ? error : maxLength ? `${currentLength}/${maxLength} characters` : undefined;

  return (
    <TextField
      {...field}
      {...props}
      margin={margin}
      fullWidth
      error={showError}
      helperText={helperText}
      value={field.value || ''}
      autoComplete="off"
      inputProps={{
        ...props.inputProps,
        maxLength
      }}
    />
  );
};

export default XTextInput;
